module.exports = __webpack_public_path__ + "img/form-bg-img1.211f81dc.png";